'use strict';

const FlowTokenV3 = require('../../HomeyAPIV3/ManagerFlowToken/FlowToken');

class FlowToken extends FlowTokenV3 {

  static transformGet(item) {
    // TODO: Remove FlowTokenV3.transform and uncomment this after front-end does not use FlowToken.uri|id|uriObj anymore!
    // item = super.transformGet(item);

    item.ownerUri = item.uri;
    item.ownerId = item.id;
    item.id = `${item.ownerUri}:${item.ownerId}`;

    delete item.ownerName; // Prepare for back-end change
    delete item.uri;
    delete item.uriObj;

    return item;
  }

}

module.exports = FlowToken;
